import React from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import './Footer.css'
import { Link } from 'react-router-dom'
import { 
  FaMapMarkerAlt, 
  FaPhone, 
  FaFacebook, 
  FaTwitter, 
  FaLinkedin, 
  FaInstagram,
  FaMobileAlt,
  FaLaptop,
  FaCreditCard,
  FaShieldAlt,
  FaLock
} from 'react-icons/fa'

import playstore from '../../assets/img/slides/playstore.png'
import appstore from '../../assets/img/slides/app-store.png'

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="modern-footer">
        <Container>
          <div className="footer-main">
            <Row className="footer-content">
              {/* Company Info & Contact */}
              <Col lg={4} md={6} className="footer-column">
                <div className="footer-brand">
                  <h3 className="footer-brand-title">GN Bank</h3>
                  <p className="footer-brand-tagline">
                    Your trusted partner in financial success. Serving our community for over 90 years.
                  </p>
                </div>
                
                <div className="footer-contact">
                  <h5 className="footer-section-title">Contact Us</h5>
                  <ul className="footer-contact-list">
                    <li>
                      <FaMapMarkerAlt className="footer-icon" />
                      <a href="/location" className="footer-link">Find a Location Near You</a>
                    </li>
                    <li>
                      <FaPhone className="footer-icon" />
                      <a href="/contact" className="footer-link">Contact Customer Service</a>
                    </li>
                  </ul>
                </div>

                <div className="footer-social">
                  <h5 className="footer-section-title">Follow Us</h5>
                  <div className="social-icons">
                    <a href="#" className="social-icon" aria-label="Facebook">
                      <FaFacebook />
                    </a>
                    <a href="#" className="social-icon" aria-label="Twitter">
                      <FaTwitter />
                    </a>
                    <a href="#" className="social-icon" aria-label="LinkedIn">
                      <FaLinkedin />
                    </a>
                    <a href="#" className="social-icon" aria-label="Instagram">
                      <FaInstagram />
                    </a>
                  </div>
                </div>

                <div className="footer-apps">
                  <h5 className="footer-section-title">Download the GN Bank app</h5>
                  <div className="app-download-buttons">
                    <a 
                      href="https://play.google.com/store/search?q=GN%20Bank&c=apps" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="app-download-link"
                      aria-label="Download on Google Play"
                    >
                      <img src={playstore} alt="Get it on Google Play" className="app-store-badge" />
                    </a>
                    <a 
                      href="https://apps.apple.com/us/app/gn-bank/id1593719853?itsct=apps_box_link&itscg=30200" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="app-download-link"
                      aria-label="Download on App Store"
                    >
                      <img src={appstore} alt="Download on the App Store" className="app-store-badge" />
                    </a>
                  </div>
                </div>
              </Col>

              {/* Banking Services */}
              <Col lg={2} md={6} className="footer-column">
                <h5 className="footer-section-title">Banking</h5>
                <ul className="footer-links">
                  <li>
                    <FaMobileAlt className="footer-link-icon" />
                    <Link to="/MobileBanking" className="footer-link">Mobile Banking</Link>
                  </li>
                  <li>
                    <FaLaptop className="footer-link-icon" />
                    <Link to="/OnlineBanking" className="footer-link">Online Banking</Link>
                  </li>
                  <li>
                    <FaCreditCard className="footer-link-icon" />
                    <Link to="/EBilling" className="footer-link">E-Bill Pay</Link>
                  </li>
                  <li>
                    <Link to="/checking" className="footer-link">Checking Accounts</Link>
                  </li>
                  <li>
                    <Link to="/savings" className="footer-link">Savings Accounts</Link>
                  </li>
                </ul>
              </Col>

              {/* Products & Services */}
              <Col lg={2} md={6} className="footer-column">
                <h5 className="footer-section-title">Products</h5>
                <ul className="footer-links">
                  <li>
                    <Link to="/loans" className="footer-link">Auto Loans</Link>
                  </li>
                  <li>
                    <Link to="/loans" className="footer-link">Home Loans</Link>
                  </li>
                  <li>
                    <Link to="/credit-cards" className="footer-link">Credit Cards</Link>
                  </li>
                  <li>
                    <Link to="/business" className="footer-link">Business Banking</Link>
                  </li>
                  <li>
                    <Link to="/location" className="footer-link">Find ATM</Link>
                  </li>
                </ul>
              </Col>

              {/* Legal & Support */}
              <Col lg={2} md={6} className="footer-column">
                <h5 className="footer-section-title">Support</h5>
                <ul className="footer-links">
                  <li>
                    <Link to="/contact" className="footer-link">Contact Us</Link>
                  </li>
                  <li>
                    <Link to="/contact" className="footer-link">Lost or Stolen Card</Link>
                  </li>
                  <li>
                    <FaShieldAlt className="footer-link-icon" />
                    <Link to="/fraud-protection" className="footer-link">Fraud Protection</Link>
                  </li>
                  <li>
                    <FaLock className="footer-link-icon" />
                    <Link to="/privacy" className="footer-link">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/fees-disclosure" className="footer-link">Fee Disclosure</Link>
                  </li>
                  <li>
                    <Link to="/terms" className="footer-link">Terms & Conditions</Link>
                  </li>
                </ul>
              </Col>

              {/* About */}
              <Col lg={2} md={6} className="footer-column">
                <h5 className="footer-section-title">About</h5>
                <ul className="footer-links">
                  <li>
                    <Link to="/about" className="footer-link">About GN Bank</Link>
                  </li>
                  <li>
                    <Link to="/news" className="footer-link">News & Updates</Link>
                  </li>
                  <li>
                    <Link to="/location" className="footer-link">Branch Locations</Link>
                  </li>
                  <li>
                    <Link to="/careers" className="footer-link">Careers</Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <p className="footer-legal">
              &copy; {currentYear} GN Bank. All Rights Reserved. Member{' '}
              <span className="footer-fdic-mark">FDIC</span>.
            </p>
          </div>
        </Container>
      </footer>
    </>
  )
}

export default Footer
